import { ref as i, h as n } from "vue";
import m from "./design-system.es195.js";
import c from "./design-system.es196.js";
const h = {
  name: "DsDropdown",
  props: {
    /**
     * Boolean to render legacy version of the dropdown. This version is deprecated and will be going away in a future release.
     */
    legacy: Boolean
  },
  setup(p, { slots: e, attrs: r, expose: u }) {
    const o = i(null);
    function a() {
      var f;
      (f = o.value) == null || f.schedulePopper();
    }
    return u({ schedulePopper: a }), () => p.legacy ? n(m, { ...r, ref: o }, e) : e.reference ? n(c, r, {
      default: e.reference,
      content: e.default
    }) : n(c, r, e);
  }
};
export {
  h as default
};
//# sourceMappingURL=design-system.es51.js.map
